export default function reducer(
  state = {
    status: 'uninitiated',
    result: {},
  },
  action
) {
  switch (action.type) {
    case 'NEW_TAG_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'NEW_TAG_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'NEW_TAG_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
